export function generateCharArray(charA, charZ) {
    var a = [], i = charA.charCodeAt(0), j = charZ.charCodeAt(0);
    for (; i <= j; ++i) {
        a.push(String.fromCharCode(i));
    }
    return a;
}

export function sortByAlphabet (list, keyExtractor = item => item) {
    return sort(Array.isArray(list) ? list : Object.values(list), keyExtractor);
}

function sort (list, keyExtractor) {
    return list.sort((a, b) => {
        const keyA = keyExtractor(a);
        const keyB = keyExtractor(b);

        if (!keyA && !keyB) {
            return 0;
        }

        if (!keyA && keyB) {
            return 1;
        }

        if (keyA && !keyB){
            return -1;
        }

        /**
         * assume we have consistent keys for sorting, e.g. no mixing locales in one word: "Zюzікофф"
         */
        if (keyA.charCodeAt(0) < 122 && keyB.charCodeAt(0) < 122) {
            return keyA.localeCompare(keyB, 'en', {ignorePunctuation: true});
        } else if (keyA.charCodeAt(0) > 122 && keyB.charCodeAt(0) > 122) {
            return keyA.localeCompare(keyB, 'uk', {ignorePunctuation: true});
        }

        return keyB.charCodeAt(0) - keyA.charCodeAt(0);
    })
}
